module.exports = __webpack_public_path__ + "img/personify-a2z-events-logo-white.4c0c9057.svg";